import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Key } from 'lucide-react'
import { KeysScreen } from '@/screens/develop/SCR-056-keys'

export const Route = createFileRoute('/_app/develop/keys')({
  staticData: {
    screen: { id: 'SCR-056', title: 'API keys', group: 'Develop', perm: 'memory.read', pin: true, order: 1, description: 'Personal tokens and service credentials: what each can do, where it works, when it was last used.', icon: Key },
  },
  validateSearch: z.object({
    tab: z.enum(['personal', 'service']).optional(),
    status: z.enum(['active', 'inactive', 'all']).optional(),
    key: z.string().max(100).optional(),
  }),
  component: KeysScreen,
})
